import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface InsufficientCreditsModalProps {
  onClose: () => void;
}

export function InsufficientCreditsModal({ onClose }: InsufficientCreditsModalProps) {
  const navigate = useNavigate();

  const handleNavigateToPricing = () => {
    navigate('/pricing');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="bg-white rounded-lg max-w-md w-full mx-4"
      >
        <div className="p-6 border-b flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <AlertTriangle className="w-6 h-6 text-amber-600" />
            </div>
            <h3 className="text-lg font-medium text-gray-900">AIクレジット不足</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-600">
            AIタイトル生成に必要なクレジットが不足しています。
            以下のいずれかの方法でクレジットを追加してください。
          </p>

          <div className="bg-blue-50 p-4 rounded-lg">
            <h4 className="font-medium text-blue-700 mb-2">クレジットを追加する方法</h4>
            <ul className="space-y-2 text-blue-600">
              <li className="flex items-start gap-2">
                <span className="font-bold">•</span>
                <span>プランをアップグレードする</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold">•</span>
                <span>追加AIクレジットを購入する</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="p-6 bg-gray-50 rounded-b-lg flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            キャンセル
          </button>
          <button
            onClick={handleNavigateToPricing}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            プラン・料金を確認
          </button>
        </div>
      </motion.div>
    </div>
  );
}